import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* searchSMS() {
  yield takeEvery(actions.SEARCH_SMS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/sms?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SMS_ENDED });
    }
  });
}

function* getSMSVerificationCode() {
  yield takeEvery(actions.GET_SMS_VERIFICATION_CODE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/sms/getVerificationCode`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_SMS_VERIFICATION_CODE_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(searchSMS), fork(getSMSVerificationCode)]);
}
